<template>
    <b-card no-body class="m-0" :class="{'border-0': fromReport}">
        <b-card-header v-if="!fromReport">
            <span>Add New Payment Method</span>
        </b-card-header>
        <b-card-body>
            <p class="mb-3 font-weight-bold">Please enter card information below</p>
            <div class="mb-3">
                <b-input-group :prepend="'Name on Card'">
                    <b-form-input class="myFeild" name="Name" placeholder="Required" v-model="getName"/>
                </b-input-group>
            </div>
            <div>
                <stripe-element-card
                    ref="elementRef"
                    :pk="pulishableKey"
                    @error="errorToken"
                    @token="tokenCreated"
                    hidePostalCode
                    @loading="v => progress = v"
                />
            </div>
            <div class="mb-3 text-danger" v-if="errorMessage">
                {{errorMessage}}
            </div>
            <div class="mb-3 text-success" v-if="successMessage">
                Card was successfully added
            </div>
            <div class="grayDisable">
                <button :disabled="progress || !getName" id="custom-button" class="btn font-weight-bold" style="background: orange" @click="createToken">
                    <span v-if="fromReport">
                        Submit Card
                    </span>
                    <span style="font-size: 1.3rem!important;height: 3rem!important;" v-else>Pay & Create Order</span>
                </button>
                <b-btn variant="warning" class="font-weight-bold mx-2" @click="cancelOperation" v-if="fromReport">
                    Cancel
                </b-btn>
            </div>
        </b-card-body>
    </b-card>
</template>

<script>
    import { StripeElementCard } from '@vue-stripe/vue-stripe';

    export default {
        name: "paymentForm",
        components: {
            StripeElementCard,
        },
        props: {
            fromReport: {default: false},
            customerName: {default: ''}
        },
        computed: {
            getName: {
                get() {
                    return this.customerName
                },
                set (val) {
                    this.customerName = val
                    // this.$emit('update:customerName', val)
                    // this.$emit('input', val)
                }
            }
            // getName () {
            //     return this.customerName
            // }
        },
        data () {
            return {
                token: null,
                cardNumber: null,
                cardExpiry: null,
                cardCvc: null,
                pulishableKey: this.$config.stripeToken,
                progress: false,
                zipcode: '',
                name: this.customerName,
                errorMessage: null,
                successMessage: false,
                testName: this.customerName
            }
        },
        methods: {
            createToken () {
                // this will trigger the process
                this.progress = true
                this.errorMessage = null
                this.successMessage = false
                setTimeout(() => {
                    this.$refs.elementRef.submit()
                    this.$nextTick(() => {
                        this.progress = false
                    })
                }, 3000)
            },
            tokenCreated (token) {
                this.errorMessage = null
                this.successMessage = true
                this.token = token
                this.$emit('input', {
                    token: token.id,
                    nameOnCard: this.getName
                })
                // this.$emit('update:customerName', this.getName)
                this.$emit('generateToken', {
                    token: token.id,
                    nameOnCard: this.getName,
                    zipcode: ''
                })
                this.$emit("createOrder")
                // handle the token
                // send it to your server
            },
            errorToken (error) {
                this.errorMessage = error.message
                this.successMessage = false
                this.token = null
                this.$emit('generateToken', {
                    token: null
                })
            },
            cancelOperation () {
                this.$emit('cancelOperation')
            }
        }
    }
</script>

<style>
    #stripe-element-errors{
        margin-top: 10px !important;
        color: red;
        display: none;
    }
</style>
